import { useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'

/**
 * Lê o parâmetro de URL `foco` e, se ele bater com `nomeDoCampo`, rola a
 * tela até o campo e foca nele automaticamente ao montar. Usado pelos
 * formulários abertos em modo obrigatório (?obrigatorio=true&foco=NomeDoCampo)
 * para indicar qual campo específico precisa de atenção.
 */
export function useFocoCampo<T extends HTMLElement = HTMLInputElement>(
    nomeDoCampo: string,
) {
    const [searchParams] = useSearchParams()
    const deveFocar = searchParams.get('foco') === nomeDoCampo
    const ref = useRef<T>(null)

    useEffect(() => {
        if (!deveFocar) return
        ref.current?.scrollIntoView({ behavior: 'smooth', block: 'center' })
        ref.current?.focus()
    }, [deveFocar])

    return { ref, deveFocar }
}
